import React from 'react';

import { useClassName } from 'common/hooks';

import Link from '../Link';
import Center from '../Center';
import useCustomStyle from '../../hooks';
import { appendStylesByPrefix } from '../../utils';

import './section-link.less';

export default function SectionLink({ component, refs }) {
  const classNames = useClassName('CLPSectionLink');
  const [setRef] = useCustomStyle(component.fields.settings);

  return (
    <Center className={classNames('container')} ref={setRef}>
      <Link
        component={appendStylesByPrefix(component, component, '--link-', true)}
        refs={refs}
      />
    </Center>
  );
}
